import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarExcluirTemplateSms
} from '../../../redux/actions/index'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import utilsSms from '../../../utils/sms'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import Table from '../../Table/index.jsx'

import EditarTemplate from './editarTempalte/editarTemplate'
import NovoTemplate from './novoTemplate/novoTemplate'

import '../../../css/painelSms/smsTemplate/tabela.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let itensVar = []
const valorLimite = 50

const TableprimaryKey = 'cd_sms_template'

function SmsTemplate(props) {
  const [itens, setItens] = useState([])
  const [dsPermissao, setDsPermissao] = useState('')
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [cdSmsContaUsuario, setCdSmsContaUsuario] = useState(undefined)
  const [itensSelecionados, setItensSelecionados] = useState()

  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )

  const [spinAtivo, setSpinAtivo] = useState(false)

  const despacho = useDispatch()
  let filtros = useSelector((state) => state.filtrosState.filtros)

  let revelarNovoTemplateSms = useSelector(
    (state) => state.smsState.revelarNovoTemplateSms
  )
  let revelarEditarTemplateSms = useSelector(
    (state) => state.smsState.revelarEditarTemplateSms
  )
  let revelarExcluirTemplateSmsState = useSelector(
    (state) => state.smsState.revelarExcluirTemplateSms
  )

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let temFiltros = false
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(473) // 'smsTemplateTabela'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    function checarFiltros() {
      if (filtros.vazio === 'vazio') {
        temFiltros = false
      } else {
        temFiltros = true
      }
    }
    checarFiltros()
  }, [filtros])

  useEffect(() => {
    if (props.filtros.vazio) {
      despacho(revelarBarraFiltragem(false))
      if (!filtros.vazio) {
        despacho(mudarFiltros({ vazio: 'vazio' }))
      }
      despacho(limpadorFiltros(true))
    }
  }, [])

  async function handleDeletarTemplate() {
    ColetaClickstream(1442) // SMSTemplateDropAcoesExcluir
    setSpinAtivo(true)
    const query = utilsSms.getNewQueryGet(
      'cd_sms_template=' + itensSelecionados.cd_sms_template
    )
    await api_gateway
      .get('/m1/deletar/smsTemplate?' + query)
      .then(function () {
        setRevelarMensagemSucesso(true)
        despacho(revelarExcluirTemplateSms(false))
        setSpinAtivo(false)
      })
      .catch(function () {
        setRevelarMensagemErro(true)
        despacho(revelarExcluirTemplateSms(false))
        setSpinAtivo(false)
      })
  }

  useEffect(() => {
    setSpinAtivo(true)
    //despacho redux
    despacho(mudarManejador('smsTemplate'))
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(true))
    async function carregarTabela() {
      setCdSmsContaUsuario(decryptJWT('cdSmsContaUsuario'))

      // clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && !temFiltros) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()

          const query = utilsSms.getNewQueryGet(
            'paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&buscar=' +
              conteudoBusca
          )
          const { data } = await api_gateway.get(
            '/m1/consultar/smsTemplate?' + query
          )
          inserirData(data.dados)
        }
      } else if (temFiltros) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = utilsSms.getNewBodyPost({
          paginaAtual: contador,
          carregarLimit: valorLimite,
          filtros: filtros,
          buscar: conteudoBusca
        })

        if (controladorPagina <= paginaAtual) {
          setItens([])
          const { data } = await api_gateway.post(
            '/m1/filtrar/smsTemplate',
            dados
          )
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const query = utilsSms.getNewQueryGet(
            'paginaAtual=' + contador + '&carregarLimit=' + valorLimite
          )
          const { data } = await api_gateway.get(
            '/m1/consultar/smsTemplate?' + query
          )
          inserirData(data.dados)
        }
      }
    }
    carregarTabela()
    setSpinAtivo(false)
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual && props.filtros.vazio) {
      const query = utilsSms.getNewQueryGet(
        'contar=true&buscar=' + conteudoBusca
      )
      apiData = await api_gateway.get('/m1/consultar/smsTemplate?' + query)
    } else {
      const dados = utilsSms.getNewBodyPost({
        paginaAtual: contador,
        carregarLimit: valorLimite,
        filtros: filtros,
        buscar: conteudoBusca,
        contar: true
      })
      apiData = await api_gateway.post('/m1/filtrar/smsTemplate', dados)
    }
    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
    itensVar = arrayItens
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const colunas = [
    {
      dataField: 'cd_sms_template',
      text: 'ID',
      hidden: true,
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ds_sms_template',
      headerClasses: 'nao-selecionavel',
      text: 'Nome',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'dt_created_at',
      headerClasses: 'nao-selecionavel',
      text: 'Data',
      sort: true,
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    },
    {
      dataField: 'dt_updated_at',
      headerClasses: 'nao-selecionavel',
      text: 'Última modificação',
      sort: true,
      formatter: (cell, row) => {
        let data = cell ? cell : row.dt_created_at
        if (data) {
          data = data.replace('T', ' ').split('.')
          if (data.length > 0) {
            data = data[0]
          }
        }
        return formatarData(data)
      }
    },
    {
      dataField: 'fl_acesso_geral',
      headerClasses: 'nao-selecionavel',
      text: 'Permissão',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell === 1 ? 'Todos usuários' : 'Somente eu'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_conteudo',
      headerClasses: 'nao-selecionavel',
      text: 'Conteúdo',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    }
  ]

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      setRenderizar(!renderizar)
      restaurarConfigsIniciaisPagina()
    }
  }

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      despacho(revelarExcluirTemplateSms(false))
      if (confirmacao === true) {
        handleDeletarTemplate()
      }
    }
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados(row)

      if (row.fl_acesso_geral === 0) {
        setDsPermissao('Todos usuários')
      } else {
        setDsPermissao('Somente eu')
      }
      despacho(desabilitarAcoes(false))
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarNovoTemplateSms === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovoTemplate
              setRenderizar={setRenderizar}
              renderizar={renderizar}
              cdSmsContaUsuario={cdSmsContaUsuario}
            />
          </div>
        </div>
      )}
      {revelarEditarTemplateSms === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <EditarTemplate
              setRenderizar={setRenderizar}
              renderizar={renderizar}
              dsNome={itensSelecionados.ds_sms_template}
              cdPermissao={itensSelecionados.fl_acesso_geral}
              dsPermissao={dsPermissao}
              dsConteudo={itensSelecionados.ds_conteudo}
              cdTemplateSms={itensSelecionados.cd_sms_template}
            />
          </div>
        </div>
      )}

      {revelarMensagemSucesso === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Template excluído."
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
      {revelarExcluirTemplateSmsState === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleMensagemAtencao}
              mensagemTitulo="Atenção"
              mensagemParagrafo1="Tem certeza que deseja excluir este template?"
              mensagemBotao="Confirmar"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemBotao="Tentar de novo"
            />
          </div>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}

export default connect(mapStateToProps)(React.memo(SmsTemplate))
